import constants from 'constants/index'

const driverId = (value) => {
  return constants.incidents.INCIDENT_DRIVER_ID[value]
}

export default driverId
